import { render } from "./SalesmanAddModal.vue?vue&type=template&id=6b419698"
import script from "./SalesmanAddModal.vue?vue&type=script&lang=js"
export * from "./SalesmanAddModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__